import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "question-list" }
const _hoisted_2 = {
  id: "submit-btn",
  style: {"padding-bottom":"10px"}
}
const _hoisted_3 = { id: "questionList" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "subquestions-list"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "subquestions" }
const _hoisted_9 = {
  key: 0,
  class: "answer-status done-icon"
}
const _hoisted_10 = {
  key: 1,
  class: "answer-status not-answered-icon"
}

import { computed, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'
import AnswerItem from '../../../common/AnswerItem'
import { IAnswerItem, IQuestion } from '../../../types'
import { IAnswer } from '../types'
import { getGroupQuestion, checkAnsweredGroup, checkBlankGroupQuestion } from '../../../lib/group-question'


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionListComponent',
  setup(__props) {

const store = useStore()

const questions = computed(() => store.state.Exam.questions as IQuestion<IAnswerItem>[])
const answers = computed(() => store.state.Exam.answers as IAnswer[])
const totalQuestionGroup = computed(() => store.getters['Exam/totalQuestionGroup'] as number)

const changeQuestion = (payload: { index: number }) => store.dispatch('Exam/changeQuestion', payload)
const submit = () => store.dispatch('Exam/submit')

const groupQuestions = computed(() => getGroupQuestion(questions.value))

const checkAnswered = (question: IQuestion<IAnswerItem>): boolean => {
  const answer = answers.value.find((answer) => answer.q_id == question.id)
  return answer && answer.body ? true : false
}

const isBlankGroupQuestion = (questions: IQuestion<IAnswerItem>[]): boolean => {
  return checkBlankGroupQuestion(questions)
}

const updateQuestionListHeight = () => {
  const elm = window.document.querySelector('#questionList') as Element
  if (elm) {
    const height = window.innerHeight - elm.getBoundingClientRect().top
    elm.setAttribute('style', 'height: ' + height + 'px')
  }
}

onMounted(() => {
  nextTick(() => {
    window.addEventListener('resize', updateQuestionListHeight)
    updateQuestionListHeight()
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeQuestion({ index: totalQuestionGroup.value }))),
        style: {"color":"#fff"},
        class: "btn-warning btn btn-primary next-answer"
      }, "テストを提出する")
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupQuestions.value, (question_group, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (isBlankGroupQuestion((question_group as any).questions))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (changeQuestion({ index: Number(index) }))
                }, "説明", 8 /* PROPS */, _hoisted_5)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (changeQuestion({ index: Number(index) })),
                  class: "question"
                }, "問題 " + _toDisplayString((question_group as any).question_index), 9 /* TEXT, PROPS */, _hoisted_7),
                _createElementVNode("ul", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((question_group as any).questions, (question, qIndex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      style: {"margin-top":"-3px"},
                      key: question.id
                    }, [
                      (checkAnswered(question))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                        : _createCommentVNode("v-if", true),
                      (!checkAnswered(question))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("span", null, "問" + _toDisplayString(Number(qIndex) + 1), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

})